import { render } from "./LocaleConfig.vue?vue&type=template&id=e4a9b23a"
import script from "./LocaleConfig.vue?vue&type=script&lang=js"
export * from "./LocaleConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__